import { ReloadGrIcon } from '../../../../../utils/SVGIcon';
import { useServiceDt } from '../ServiceDetailsProvider';

function ButtonWrapper({ children, className, onClick }) {
    return (
        <button
            type="button"
            className={`h-[34px] text-sm font-e text-secondary bg-[rgba(255,255,255,0.80)] backdrop-blur-[2px] rounded-5 ${className}`}
            onClick={onClick}
        >
            {children}
        </button>
    );
}

function ProductDetails({ serviceInfo }) {
    return (
        <div
            className={`flex flex-row gap-4 items-center  ${
                serviceInfo?.demo ? 'placeholder-mode' : ''
            }`}
        >
            <div className="flex flex-col items-start">
                <span className="text-primary text-2xl font-medium whitespace-nowrap text-ellipsis">
                    {serviceInfo?.serviceTitle || '-----------'}
                </span>
                <p className="text-sm text-primary">
                    <span>{serviceInfo?.description || '-------------'}</span>
                </p>
            </div>
        </div>
    );
}

function ServiceInfo() {
    const { openModal, serviceInfo, handleReload } = useServiceDt();

    return (
        <div className="flex items-center relative w-full h-16 p-3 mb-4 product-bg">
            <div className="w-full h-full flex items-center z-10">
                <ProductDetails serviceInfo={serviceInfo} />
            </div>

            <div className="flex items-center gap-x-2.5 top-2.5 right-2.5 z-20">
                <ButtonWrapper className="w-[34px] p-1" onClick={handleReload}>
                    <ReloadGrIcon />
                </ButtonWrapper>
                <ButtonWrapper
                    className="w-[100px] px-2.5 py-2"
                    onClick={() => openModal('editService', serviceInfo)}
                >
                    Edit Service
                </ButtonWrapper>
            </div>
        </div>
    );
}

export default ServiceInfo;
